/*
 * wp-shared.js
 * WordPress版 assets/js/shared.js・modules/utility.js 由来の共通挙動を集約。
 * Shopify テーマ assets/ に配置し、移行ページで {{ 'wp-shared.js' | asset_url }} で読み込む。
 * （共通CSSの wp-shared.css と対になる共通JS。ページ固有のJSは各テンプレートにインラインする）
 */
(function () {
  "use strict";

  /**
   * 対象要素がビューポートに入ったら is-animated を付与する（元 utility.js の scrollAddClass）。
   * .c-image::before の不透明オーバーレイは .c-image.is-animated で消えるため、この付与が必須。
   * ページ固有セレクタにも使えるよう window.wpShared.scrollAddClass として公開する。
   *
   * @param {string} selector 対象セレクタ
   * @param {{startDelay?: number, mode?: "default"|"alternate"}} [args]
   */
  function scrollAddClass(selector, args) {
    selector = selector || ".js-scroll-add-class";
    var settings = Object.assign({ startDelay: 0.25, mode: "default" }, args || {});
    var allElem = document.querySelectorAll(selector);

    Array.prototype.slice.call(allElem).forEach(function (elem) {
      var offsetTop = elem.getBoundingClientRect().top + window.scrollY;
      var startDelay = elem.dataset.startDelay || settings.startDelay;

      if (
        window.scrollY + window.innerHeight - window.innerHeight * startDelay >=
        offsetTop
      ) {
        if (!elem.classList.contains("is-animated")) {
          elem.classList.add("is-animated");
          elem.dispatchEvent(new Event("classAdded"));
        }
      } else if (settings.mode === "alternate") {
        elem.classList.remove("is-animated");
      }
    });
  }

  // ページ固有の呼び出し用に公開
  window.wpShared = window.wpShared || {};
  window.wpShared.scrollAddClass = scrollAddClass;

  // 共通: .c-image の表示（全移行ページ共通。shared.js と同じく load/scroll/resize で発火）
  var revealImages = function () {
    scrollAddClass(".c-image");
  };

  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", revealImages);
  } else {
    revealImages();
  }
  window.addEventListener("load", revealImages);
  window.addEventListener("scroll", revealImages, { passive: true });
  window.addEventListener("resize", revealImages);

  /**
   * Swiper の画像高さを CSS 変数へ反映（元 MySwiper.setImgHeight 相当）。
   * `.swiper-button { top: calc(var(--swiper-img-h) * 0.5) }` のようにボタンを画像の縦中央へ置くページ用。
   * 素の `new Swiper()` で初期化するページ（DPP 等）は MySwiper を経由せず変数が未設定になるため、
   * 初期化済みの全 .swiper に対して共通で設定する。ボタンが wrapper 外にある場合は親要素にも反映する。
   */
  function syncSwiperImgHeight() {
    Array.prototype.slice.call(document.querySelectorAll(".swiper")).forEach(function (el) {
      var swiper = el.swiper;
      var slide = el.querySelector(".swiper-slide");
      var img = slide && slide.querySelector("img");
      if (!swiper || !img || !img.clientHeight) return;

      // ブレークポイント切替・リサイズ後の Swiper 再レイアウトで画像高さが変わるため、画像サイズの変化も監視する
      if (window.ResizeObserver && !el.__wpImgObserver) {
        el.__wpImgObserver = new ResizeObserver(function () {
          syncSwiperImgHeight();
        });
        el.__wpImgObserver.observe(img);
      }

      var height = img.clientHeight + "px";
      el.style.setProperty("--swiper-wrapper-h", swiper.wrapperEl.clientHeight + "px");
      el.style.setProperty("--swiper-img-h", height);

      var nav = swiper.navigation || {};
      [nav.nextEl, nav.prevEl].forEach(function (button) {
        if (button && button.parentElement && !swiper.wrapperEl.contains(button)) {
          button.parentElement.style.setProperty("--swiper-img-h", height);
        }
      });
    });
  }

  // ページ固有スクリプトの Swiper 初期化（load 時など）より後に反映するため、遅延して複数回実行する
  window.addEventListener("load", function () {
    [0, 300, 1000, 2500].forEach(function (delay) {
      setTimeout(syncSwiperImgHeight, delay);
    });
  });
  window.addEventListener("resize", syncSwiperImgHeight);
})();
